// Página da Folha de Pagamento dentro do sistema FSC (menu "Folha de pagamento", abaixo de Fiscal).
// Usa o mesmo login do sistema: todas as chamadas passam pela portaria /api/folha do backend,
// que amarra cada requisição ao cliente logado. A chave da API da Folha nunca vai ao navegador.
//
// Instalação: copie a pasta src desta Folha para frontend/src/folha (ao lado de frontend/src/fiscal) e
//   <Route path="/app/folha/*" element={<FolhaPagamento />} />
import React, { useEffect, useState } from 'react'
import FolhaModuleEtapa6 from './FolhaModuleEtapa6'
import { configureFolhaApiEtapa6 } from './etapa6/api'
import { caminhoCertificado, tokenAtual } from '../fiscal/api'

const BASE = `${process.env.REACT_APP_BACKEND_URL || ''}/api/folha`
const cabecalhos = async () => {
  const t = tokenAtual()
  return t ? { Authorization: `Bearer ${t}` } : {}
}

let configurado = false
function configurar() {
  if (configurado) return
  configureFolhaApiEtapa6({ baseUrl: `${BASE}/v1`, getHeaders: cabecalhos })
  configurado = true
}

const dataBR = (v) => (v ? new Date(v).toLocaleDateString('pt-BR') : '')

function CartaoCertificado({ cert }) {
  const link = caminhoCertificado() || '/app/sistema/empresa'
  let cor = 'border-emerald-200 bg-emerald-50 text-emerald-900'
  let texto = `Certificado digital ativo${cert.valido_ate ? ` até ${dataBR(cert.valido_ate)}` : ''}, autorizado para o eSocial.`
  if (cert.status === 'ausente') {
    cor = 'border-amber-300 bg-amber-50 text-amber-900'
    texto = 'Nenhum certificado digital cadastrado. Ele será necessário para transmitir ao eSocial.'
  } else if (cert.status === 'expirado') {
    cor = 'border-red-300 bg-red-50 text-red-800'
    texto = 'Certificado digital vencido. Envie um novo para transmitir ao eSocial.'
  } else if (!cert.autorizado_esocial) {
    cor = 'border-amber-300 bg-amber-50 text-amber-900'
    texto = 'Aceite o novo termo de autorização (versão 3.0) para usar o certificado no eSocial.'
  } else if (cert.status === 'vence_em_breve') {
    cor = 'border-amber-300 bg-amber-50 text-amber-900'
    texto = `Certificado digital vence em ${dataBR(cert.valido_ate)}. Providencie a renovação.`
  }
  return (
    <div className={`mb-3 flex flex-wrap items-center justify-between gap-2 rounded-md border px-3 py-2 text-sm ${cor}`}>
      <span>{texto} <span className="opacity-75">Transmissão automática ao eSocial: em preparação (Etapa 7).</span></span>
      <a href={link} className="font-medium underline">Minha empresa → Certificado digital</a>
    </div>
  )
}

export default function FolhaPagamento() {
  configurar()
  const [sessao, setSessao] = useState(null)
  const [erro, setErro] = useState(null)

  useEffect(() => {
    let vivo = true
    ;(async () => {
      try {
        const r = await fetch(`${BASE}/sessao`, { headers: await cabecalhos() })
        const d = await r.json().catch(() => null)
        if (!r.ok) throw new Error(d?.detail || `Erro ${r.status}`)
        if (vivo) setSessao(d)
      } catch (e) {
        if (vivo) setErro(e.message)
      }
    })()
    return () => { vivo = false }
  }, [])

  if (erro) return <div className="m-4 rounded-md border border-red-300 bg-red-50 p-3 text-sm text-red-800">{erro}</div>
  if (!sessao) return <p className="m-4 text-sm text-gray-500">Carregando…</p>
  if (!sessao.folha_disponivel) {
    return <div className="m-4 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
      Folha de Pagamento indisponível no servidor. Avise o suporte da FSC Sistemas.</div>
  }
  return (
    <div className="mx-auto max-w-7xl p-4">
      <h1 className="mb-1 text-xl font-semibold">Folha de pagamento</h1>
      {sessao.razao_social && <p className="mb-3 text-sm text-gray-600">{sessao.razao_social}{sessao.cnpj ? ` · CNPJ ${sessao.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')}` : ''}</p>}
      <CartaoCertificado cert={sessao.certificado} />
      <FolhaModuleEtapa6 empresaId={sessao.empresa_id} />
    </div>
  )
}
